/*Analytics*/
analytics.eventConfig.push(
    {
        "target": ".component.b03-image",
        "codeId": "b03",
        "events": [
            {
                "eventTarget": "a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "b03",
                    "componentName": "image",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "generic image",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": "a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "b03",
                    "componentName": "image",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "generic image",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().startsWith('mailto:') || $(context).attr('href').toLowerCase().startsWith('tel'))",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                            "value": "click to call"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "image internal navigation click"
                        }
                    ],
                    "fileName": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            }
        ]
    }
)